module.exports = __webpack_public_path__ + "815b5345bf1de5a19ef1da0ac2308f81.jpeg";